module.exports = __webpack_public_path__ + "img/icon-team.e6286f78.png";